<script setup>
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    z: {
        type: Number,
        default: 0,
    },
    class: String,
});

const emit = defineEmits(["update:modelValue"]);

const classes = computed(() => {
    let classes = ["w-4 h-4 rounded disabled:opacity-50", "text-gray-900 bg-white border-gray-300 disabled:text-gray-900"];

    switch (props.z) {
        case 3:
            classes.push("dark:text-gray-400 dark:border-gray-200 dark:disabled:text-gray-400");
            break;
        case 2:
            classes.push("dark:text-gray-500 dark:border-gray-300 dark:disabled:text-gray-500");
            break;
        case 1:
            classes.push("dark:text-gray-600 dark:border-gray-400 dark:disabled:text-gray-600");
            break;
        default:
            classes.push("dark:text-gray-700 dark:border-gray-500 dark:disabled:text-gray-700");
            break;
    }

    return twMerge(classes, props.class);
});
</script>

<template>
    <input type="checkbox" :class="classes" :checked="modelValue" @change="emit('update:modelValue', $event.target.checked)" />
</template>
